import React from "react";

import "./Photos.css";

export default function Photos(props) {
  if (props.photos) {
    if (props.photos.length > 0) {
      return (
        <section className="Photos">
          <div className="row">
            {props.photos.map(function (photo, idx) {
              return (
                <div key={idx} className="col-12 col-sm-6 col-md-3">
                  <a href={photo.src.original} target="_blank" rel="noreferrer">
                    <img
                      src={photo.src.landscape}
                      className="img-fluid"
                      alt={photo.alt}
                    />
                  </a>
                </div>
              );
            })}
          </div>
        </section>
      );
    }
  }
  return null;
}
